var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#71E0EC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.991c-2.213 0-4.007-1.9-4.007-4.243c0-2.28 3.618-6.302 3.767-6.46l.18-.221l.18.221c.149.159 3.857 4.18 3.857 6.46c.03 2.343-1.764 4.243-3.977 4.243M11.97 6.89c-.329.38-.987 1.14-1.645 2.09c-1.165 1.646-1.794 2.944-1.794 3.768c0 2.026 1.555 3.673 3.469 3.673s3.468-1.647 3.468-3.673c0-.824-.628-2.122-1.824-3.768c-.658-.919-1.345-1.71-1.674-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.353c-2.93 0-5.293-2.502-5.293-5.605c0-3.008 3.978-7.22 4.157-7.41a.3.3 0 0 1 .388 0a.35.35 0 0 1 0 .412c-.06.032-4.006 4.212-4.006 6.998S9.368 17.782 12 17.782s4.754-2.248 4.754-5.034c0-1.14-.688-2.723-2.003-4.56a26 26 0 0 0-2.033-2.501c-.12-.096-.12-.285 0-.412c.09-.127.268-.127.388 0c.18.19 4.216 4.465 4.216 7.473c-.03 3.103-2.392 5.605-5.322 5.605"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.714c-3.529 0-6.429-3.072-6.429-6.808c0-1.551.748-3.451 2.183-5.668a27 27 0 0 1 2.183-2.85c.09-.126.269-.126.388 0c.12.096.12.285 0 .412c0 0-1.076 1.172-2.122 2.786c-1.376 2.09-2.093 3.927-2.093 5.352c0 3.451 2.661 6.238 5.89 6.238s5.89-2.85 5.89-6.27c0-1.425-.717-3.262-2.093-5.35c-1.046-1.584-2.123-2.756-2.123-2.787a.35.35 0 0 1 0-.412a.3.3 0 0 1 .389 0c.15.221 4.365 4.844 4.365 8.55c0 3.735-2.87 6.807-6.428 6.807"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrm);
export default __webpack_public_path__ + "static/media/srm.2bedc6ec834e1d8342ecb0e16a206e51.svg";
export { ForwardRef as ReactComponent };